var React = require('react');

function ChevronDoubleUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M435 420.86a24 24 0 0 1 0 33.94l-22.63 22.67a23.93 23.93 0 0 1-33.85 0L224 323.5l-154.5 154a23.93 23.93 0 0 1-33.85 0L13 454.8a24 24 0 0 1 0-33.94l194-194.33a23.93 23.93 0 0 1 33.88 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M435 228.86a24 24 0 0 1 0 33.94l-22.63 22.67a23.93 23.93 0 0 1-33.85 0L224 131.5l-154.5 154a23.93 23.93 0 0 1-33.85 0L13 262.8a24 24 0 0 1 0-33.94L207 34.53a23.93 23.93 0 0 1 33.88 0z","className":"fa-primary","key":2})]);
}

ChevronDoubleUp.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ChevronDoubleUp;

ChevronDoubleUp.default = ChevronDoubleUp;
